import { redirect } from 'next/navigation';
import { API_URL } from '@/utils/constants';

export const request = async <ResponseType>(url: string, opts?: RequestInit) => {
  const response = await fetch(`${API_URL}${url}`, {
    ...opts,
    headers: {
      ...(opts && opts.headers),
    },
  });

  if (response.status === 404) {
    redirect('/not-found');
  }

  if (!response.ok) {
    const json = await response.json().then((json) => json);

    throw new Error(JSON.stringify({ status: response.status, error: json }));
  }

  return response.json() as ResponseType;
};
